import { NavigationGuardNext } from 'vue-router'
import AuthService from '@/plugins/api-plugin/services/auth.service'

export default async function guestMiddleware({
    next,
    nextMiddleware,
}: {
    next: NavigationGuardNext
    nextMiddleware: NavigationGuardNext
}) {
    if (!AuthService.isAuth()) {
        location.href = `${process.env.VUE_APP_CO_BASE_URL}/Account/Logout`

        return nextMiddleware()
    }
    return next({ path: '/redirecting' })
}
